import React, { createContext, useContext, useState } from "react";

const FileManagerContext = createContext();

export const FileManagerProvider = ({ children }) => {
    const [currentFolder, setCurrentFolder] = useState("");
    const [imageToEdit, setImageToEdit] = useState(null);
    const [noteToEdit, setNoteToEdit] = useState(null);
    
    return (
        <FileManagerContext.Provider value={{ currentFolder, setCurrentFolder, imageToEdit, setImageToEdit, noteToEdit, setNoteToEdit }}>
            {children}
        </FileManagerContext.Provider>
    );
};

export const useFileManager = () => {
    return useContext(FileManagerContext);
};
